import { types, actions } from './requests'
export const GETPRODUCTLIST_TYPES = {
    ...types('GETPRODUCTLIST'),
}
export const GETPRODUCTLIST_ACTIONS = {
    ...actions('GETPRODUCTLIST'),
}
